import React from "react";
import { twMerge } from "tailwind-merge";

export default function Card({ children, classNames }) {
  return (
    <span
      className={twMerge(
        "block relative rounded bg-white/70 backdrop-blur-xl p-6 shadow",
        classNames
      )}
    >
      {children}
    </span>
  );
}
